import { render, staticRenderFns } from "./ApopointCMS.vue?vue&type=template&id=5a7ecbfe&scoped=true"
import script from "./ApopointCMS.vue?vue&type=script&lang=js"
export * from "./ApopointCMS.vue?vue&type=script&lang=js"
import style0 from "./ApopointCMS.vue?vue&type=style&index=0&id=5a7ecbfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7ecbfe",
  null
  
)

export default component.exports